import { Locale, Translation } from 'locale'
import { create, IndicatorColor } from 'openfin-notifications'
import { hasBrowserNotificationsEnabled, isOpenFin } from 'utils'
import { ToastColor, ToastNotificationMessage } from 'view/routes/requests/shared/toastUtils'
import notificationIcon from './assets/notificationIcon.png'
import { routerService } from './routerService'

export interface NotificationService {
  createNotification: (msg: ToastNotificationMessage) => void
}

export const EVENT_NOTIFICATION_CLICKED = 'btq-notification-clicked'

export const openFinNotificationService: NotificationService = {
  createNotification: (msg: ToastNotificationMessage) =>
    create({
      indicator: {
        color: toastColorToOpenFinNotificationColorMapper(msg.subStatusTextGrey ? ToastColor.GRAY : msg.statusColour),
        text: msg.statusText + (msg.subStatusText.length > 0 ? ` - ${msg.subStatusText}` : '')
      },
      icon: notificationIcon,
      priority: msg.priority,
      title: `${msg.organisationName} - ${msg.tradingEntityName}`,
      body: Locale.translate(Translation.SC_YOU_HAVE_RECEIVED_EVENTS, {
        count: msg.count,
        statusText: msg.statusText.toLowerCase()
      }),
      category: Locale.translate(Translation.TC_NOTIFICATION_CATEGORY),
      buttons: [
        {
          cta: false,
          title: Locale.translate(Translation.TC_VIEW_QUEUE),
          onClick: {
            task: EVENT_NOTIFICATION_CLICKED,
            customData: msg.onClickPath
          }
        }
      ]
    })
}

export const createBrowserNotificationService = (): NotificationService => ({
  createNotification: (msg: ToastNotificationMessage) => {
    if (!isOpenFin() && hasBrowserNotificationsEnabled()) {
      const title = `${msg.organisationName} - ${msg.tradingEntityName}`
      const body = Locale.translate(Translation.SC_YOU_HAVE_RECEIVED_EVENTS, {
        count: msg.count,
        statusText: msg.statusText.toLowerCase()
      })

      const notification = new Notification(title, { body, icon: notificationIcon })

      const clickHandler = () => {
        window.focus()
        routerService.navigate(msg.onClickPath)
        notification.close()
        notification.removeEventListener('click', clickHandler)
      }

      notification.addEventListener('click', clickHandler)
    }
  }
})

const toastColorToOpenFinNotificationColorMapper = (color: ToastColor): IndicatorColor => {
  switch (color) {
    case ToastColor.RED:
      return IndicatorColor.RED

    case ToastColor.GREEN:
      return IndicatorColor.GREEN

    case ToastColor.YELLOW:
      return IndicatorColor.YELLOW

    case ToastColor.PURPLE:
      return IndicatorColor.PURPLE

    case ToastColor.BLUE:
      return IndicatorColor.BLUE

    case ToastColor.GRAY:
    default:
      return IndicatorColor.BLUE
  }
}
